import type { SVGProps } from "react";

// Camera body with a circular arrow — Door Check-In's front/back switch.
const SwitchCameraIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 7.08333C2.5 6.16286 3.24619 5.41667 4.16667 5.41667H5.83333L7.08333 3.75H12.9167L14.1667 5.41667H15.8333C16.7538 5.41667 17.5 6.16286 17.5 7.08333V14.5833C17.5 15.5038 16.7538 16.25 15.8333 16.25H4.16667C3.24619 16.25 2.5 15.5038 2.5 14.5833V7.08333Z"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9.16667C12.0583 8.16667 11.1083 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10M7.5 11.6667C7.94167 12.6667 8.89167 13.3333 10 13.3333C11.3807 13.3333 12.5 12.214 12.5 10.8333M12.5 7.5V9.16667H10.8333M7.5 13.3333V11.6667H9.16667"
        stroke="currentColor"
        strokeWidth="1.45833"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SwitchCameraIcon;
